const baseUploaderConfig = {
  allowMultiple: true,
  maxFiles: 1000,
  checkValidity: true,

  allowFileSizeValidation: true,

  labelMaxFileSizeExceeded: 'حجم فایل زیاد است',
  labelMaxFileSize: 'حداکثر حجم مجاز: {filesize}',

  allowFileTypeValidation: true,
  labelFileTypeNotAllowed: 'فایل انتخابی مجاز نیست',

  server: {
    url: 'https://dl9.projectsd.ir/Uploader',
    process: '/Process',
  },

  labelIdle: 'فایل را اینجا رها یا کلیک کنید',
  labelInvalidField: 'فایل معتبر نیست',
  labelFileProcessing: 'درحال بارگذاری',
  labelFileProcessingError: 'خطا در بارگذاری',
  labelFileLoading: 'درحال بارگیری',
  labelFileLoadError: 'خطا در بارگیری',
  labelFileProcessingComplete: 'بارگذاری موفق',
  labelFileProcessingAborted: 'لغو بارگذاری',
  labelFileProcessingRevertError: 'خطا در بازگشتن',
  labelFileRemoveError: 'خطا در حذف',
  labelTapToCancel: 'لغو',
  labelTapToRetry: 'تلاش مجدد',
  labelTapToUndo: 'بازگردانی',
  labelButtonRemoveItem: 'حذف',
  labelButtonRetryItemLoad: 'تلاش مجدد',
  labelButtonAbortItemProcessing: 'لغو',
  labelButtonUndoItemProcessing: 'بازنشانی',
  labelButtonRetryItemProcessing: 'تلاش مجدد',
  labelButtonProcessItem: 'بارگذاری',
};

const imageUploaderConfig = {
  allowFilePoster: true,
  maxFileSize: '1MB',

  allowImagePreview: true,
  imagePreviewMaxHeight: 300,

  allowImageValidateSize: true,

  filePosterMinHeight: 100,
  filePosterMaxHeight: 300,

  acceptedFileTypes: ['image/png', 'image/jpeg', 'image/jpg'],

  labelIdle: 'عکس را اینجا رها یا کلیک کنید',
};

const applicationFileUploaderConfig = {
  allowMultiple: false,
  maxFiles: 1,
  maxFileSize: '500MB',

  acceptedFileTypes: [
    'application/vnd.android.package-archive',
    '.apk',
    '.aab',
    '.ipa',
    '.exe',
    '.msi',
    '.dmg',
  ],

  labelIdle: 'فایل برنامه را اینجا رها یا کلیک کنید',
};

export {
  applicationFileUploaderConfig,
  baseUploaderConfig,
  imageUploaderConfig,
};
